const rem = (size) => {
  return `${size / 37.5}rem`;
}

const createTheme = () => ({
  backgroundColor: {
    primary: 'linear-gradient(180deg, #00a3da, #0076c2)',
    secondary: '#ffffff',
    tertiary: '#14204a',
    mask: 'rgba(112,113,116,.7)'
  },
  borderColor: {
    primary: '#e4e5e8',
    secondary: '#fff',
    tertiary: '#f1f1f3',
  },
  fontColor: {
    primary: '#767b8e',
    secondary: '#ffffff',
    tertiary: '#14204a',
    quaternary: '#009fe3',
  },
  fontSize: {
    xxl: '24px',
    xl: '20px',
    lg: '18px',
    md: '16px',
    sm: '14px',
    xs: '12px',
  },
  fontFamily: {
    primary: 'Lato, sans-serif',
    secondary: 'Roboto, sans-serif',
  },
  shadowColor: [
    'rgba(0, 0, 0, 0.13)',
    'rgba(0, 0, 0, 0.2)',
    'rgba(0, 0, 0, .25)',
    'rgba(0, 0, 0, .3)',
    '0px 0px 10px ',
    '-10px 0px 20px rgba(0, 0, 0, .25)',
    '0 6px 45px 0 ',
  ],
  transition: {
    smooth: 'cubic-bezier(.165,.84,.44,1)',
  },
  rem,
});

export default createTheme;
